import { Controller } from "@hotwired/stimulus";
import { useIntersection } from "stimulus-use";
import Quill from 'quill';


// Connects to data-controller="quill"
export default class extends Controller {
  static values = {
    loaded: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  }

  static targets = ['editor', 'input']

  connect() {
    useIntersection(this);
  }

  appear(entry) {
    if (this.loadedValue) return;

    this.quill = new Quill(this.editorTarget, {
      theme: 'snow',
      readOnly: this.readonlyValue,
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }]
        ]
      },
    });
    this.quill.on("text-change", (...args) => {
      this.inputTarget.value = this.quill.root.innerHTML;
    });
    this.loadedValue = true;
  }
}
